// ./frontend/src/reducers/userReducer.js
import { LOGIN_SUCCESS, LOGIN_FAILED, LOGOUT,SET_USER_DATA,EMAIL_SENT } from "../config";

const INITIAL_STATE={
  authenticate:null,
  details:{}
}
export function userReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case LOGIN_SUCCESS:
      state = {
          ...state, 
          details:action.user,
          authenticate:true
        };
      return state;
    case LOGIN_FAILED:
      state = {
          ...state, 
          details:action.user,
          authenticate:false
        };
      return state;
	case EMAIL_SENT:
      state = {...state, emailId:action.emailId};
      return state;
    case LOGOUT:
      return INITIAL_STATE;
	case SET_USER_DATA:
		state = {...state, UserDetails:action.userDetails};
      return state;
    default:
      return state;
  }
}